import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <g>
        <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
        <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
        <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
        <path fill='#2378B1' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z' />
        <g>
          <path
            fill='#FFFFFF'
            d='M104.5,303.2c0-10.8,16.9-10.8,16.9,0v50.5c0,20.1-9.6,32.3-31.7,32.3c-10.9,0-20-3-27.9-13.2 c-6.5-7.8,5.8-19.1,12.4-10.9c5.4,6.7,11.1,8.2,16.8,7.9c7.2-0.3,13.4-3.5,13.6-16.1L104.5,303.2L104.5,303.2L104.5,303.2z'
          />
          <path
            fill='#FFFFFF'
            d='M140.3,304.5c0-4.2,3.3-8.8,8.7-8.8h29.6c16.6,0,31.6,11.1,31.6,32.5c0,20.2-15,31.5-31.6,31.5h-21.4v16.9 c0,5.6-3.6,8.8-8.2,8.8c-4.2,0-8.7-3.2-8.7-8.8L140.3,304.5L140.3,304.5z M157.2,311.8v31.9h21.4c8.6,0,15.4-7.6,15.4-15.5 c0-8.9-6.8-16.4-15.4-16.4H157.2z'
          />
          <path
            fill='#FFFFFF'
            d='M373.6,371.1c-9.1,7.6-20.2,10.8-31.5,10.8c-26.9,0-45.9-15.3-45.9-45.8c0-25.8,20.1-45.9,47.1-45.9 c10.1,0,21.2,3.4,29.2,11.2c7.8,7.7-3.5,19.1-11.1,12.3c-4.7-4.6-11.4-8.1-18-8.1c-15.5,0-30.4,12.4-30.4,30.4 c0,18.9,12.5,30.5,29.3,30.5c7.8,0,14.4-2.3,19.2-5.8V345h-19.2c-11.4,0-10.2-15.6,0-15.6h25.6c4.7,0,9.1,3.6,9.1,7.6v27.2 C376.8,366.5,375.8,368.7,373.6,371.1z'
          />
          <path
            fill='#FFFFFF'
            d='M231.4,380.3c-4.5,0-7.9-3.3-7.9-7.6v-69.9c0-4.4,3.5-7.6,7.9-7.6h45.9c11.8,0,11.5,16,0,16h-36.8v18.5h32.2 c11.4,0,11.4,16.1,0,16.1h-32.2v18.5h39c11.6,0,12.5,16.1,0,16.1H231.4z'
          />
        </g>
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
    </svg>
  );
});

export default React.memo(Icon);
